<template>
  <section class="policy policy--cookies" tabindex="-1">
    <div class="corner-accent" aria-hidden="true"></div>
    <div class="container">
      <div class="intro">
        <div>
          <p class="eyebrow">SERVIÇOS</p>
          <h1>{{ dataList.infotop.title }}</h1>
        </div>
        <p class="lede" v-html="dataList.infotop.description"></p>
      </div>

      <ul class="accordion" role="list">
        <li
          v-for="(policy, index) in dataList.listpolicy"
          :key="policy.detailspolicys.schemaId"
          class="accordion__item"
          :class="{ 'is-active': activeIndex === index }"
        >
          <button
            class="accordion__button"
            :aria-expanded="activeIndex === index ? 'true' : 'false'"
            :aria-controls="`panel-${policy.detailspolicys.schemaId}`"
            :id="`control-${policy.detailspolicys.schemaId}`"
            @click="toggle(index)"
          >
            <span class="accordion__title">{{ policy.detailspolicys.title }}</span>
            <span class="accordion__summary">{{ policy.detailspolicys.resumo }}</span>
            <span class="accordion__cta" aria-hidden="true"></span>
          </button>

          <div
            class="accordion__panel"
            role="region"
            :id="`panel-${policy.detailspolicys.schemaId}`"
            :aria-labelledby="`control-${policy.detailspolicys.schemaId}`"
            v-show="activeIndex === index"
          >
            <div class="accordion__content" v-html="policy.detailspolicys.description"></div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
export default {
  name: 'CookiesPolicy',
  metaInfo: {
    title: 'Política de Cookies - Ucall'
  },
  data () {
    return {
      dataList: { infotop: {}, listpolicy: [] },
      activeIndex: 0
    }
  },
  computed: {
    appConfig () {
      return this.$store.getters.appConfig
    },
  },
  watch: {
    '$i18n.locale': {
      handler: async function () {
        await this.get()
      }
    }
  },
  methods: {
    toggle (index) {
      this.activeIndex = this.activeIndex === index ? -1 : index
    },

  async get () {
      await axios
        .get(`${process.env.VUE_APP_SQUIDEX_URL}/api/content/${process.env.VUE_APP_SQUIDEX_APP_NAME}/policycookies`, {
          headers: {
            'X-Resolve-Urls': 'logotipo,banner,imageabout,foto',
            'X-Languages': this.$i18n.locale,
            'X-Flatten': true,
            'X-Resolve-Reference': 'oradores,parceiros,logotipo,foto'
          }
        })
        .then((resp) => {
          console.log("resp",resp)
          let newData = []
          newData = resp.data.items.map(item => {
            const data = item.data

            if (data.oradores) {
              data.oradores.forEach(orador => {
                orador.foto = orador.foto.map(id => `${process.env.VUE_APP_SQUIDEX_URL}/api/assets/${process.env.VUE_APP_SQUIDEX_APP_NAME}/${id}`)
              })
            }

            if (data.parceiros) {
              data.parceiros.forEach(parceiro => {
                parceiro.logotipo = parceiro.logotipo.map(id => `${process.env.VUE_APP_SQUIDEX_URL}/api/assets/${process.env.VUE_APP_SQUIDEX_APP_NAME}/${id}`)
              })
            }

            return item
          })

          this.dataList = newData[0].data
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log(error)
          /* eslint-enable no-console */
        })
    }
  },

  async mounted () {
    await this.get()
  },

}
</script>

<style lang="scss" scoped>
/* Prevent horizontal scroll globally */
* {
  box-sizing: border-box;
}

.policy {
  position: relative;
  padding: clamp(6rem, 10vw, 9rem) clamp(1rem, 3vw, 1.5rem) clamp(4rem, 8vw, 7rem);
  color: #1d1d1f;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  background: #fff;

  .corner-accent {
    position: absolute;
    top: 0;
    right: 0;
    width: clamp(140px, 30vw, 320px);
    height: clamp(140px, 30vw, 320px);
    background: linear-gradient(135deg, #c42462 0%, #7a1a3d 100%);
    clip-path: polygon(100% 0, 100% 100%, 0 0);
    pointer-events: none;
    z-index: 0;
  }

  .container {
    position: relative;
    z-index: 1;
    max-width: min(1000px, 95vw);
    width: 100%;
    margin: 0 auto;
    line-height: 1.75;
    box-sizing: border-box;
    overflow-x: hidden;
  }

  .intro {
    display: grid;
    grid-template-columns: 1fr;
    gap: clamp(0.5rem, 2vw, 1rem) clamp(1rem, 4vw, 2rem);
    align-items: start;
    margin-bottom: clamp(1.5rem, 4vw, 2.5rem);

    .eyebrow {
      display: inline-block;
      font-size: clamp(0.7rem, 2vw, 0.75rem);
      letter-spacing: .12em;
      text-transform: uppercase;
      color: #dc1c2e;
      font-weight: 700;
      margin: 0 0 clamp(0.25rem, 1vw, 0.5rem);
    }

    .lede {
      color: #4b5563;
      margin: clamp(0.25rem, 1vw, 0.5rem) 0 clamp(0.5rem, 2vw, 1rem);
      font-size: clamp(0.9rem, 2.5vw, 1.0625rem);
      line-height: 1.6;
    }
  }

  h1 {
    font-size: clamp(1.5rem, calc(4vw + 1rem), 2.5rem);
    line-height: 1.2;
    margin: 0 0 clamp(0.75rem, 2vw, 1rem);
    color: #1d1d1f;
    text-transform: uppercase;
    word-break: break-word;
    position: relative;
    display: inline-block;
  }
  h1::after {
    content: "";
    display: block;
    width: clamp(48px, 10vw, 72px);
    height: 5px;
    background: linear-gradient(90deg, #dc1c2e, #f2a900);
    border-radius: 3px;
    margin-top: clamp(0.5rem, 2vw, 0.75rem);
  }

  p {
    margin: 0 0 clamp(0.75rem, 2vw, 1rem);
    font-size: clamp(0.9rem, 2.5vw, 1.0625rem);
    color: #273249;
    overflow-wrap: anywhere;
    word-break: break-word;
    line-height: 1.6;
  }

  h2 {
    margin: clamp(1.5rem, 4vw, 2rem) 0 clamp(0.5rem, 2vw, 0.75rem);
    font-size: clamp(1.1rem, 3vw, 1.5rem);
    line-height: 1.3;
    color: #111827;
    position: relative;
    word-break: break-word;
  }

  h2::after {
    content: "";
    display: block;
    width: clamp(32px, 8vw, 48px);
    height: clamp(2px, 0.5vw, 3px);
    background: #dc1c2e; /* brand accent */
    border-radius: 2px;
    margin-top: clamp(6px, 1.5vw, 8px);
  }

  ul {
    padding-left: clamp(1rem, 3vw, 1.25rem);
    margin: clamp(0.25rem, 1vw, 0.5rem) 0 clamp(0.75rem, 2vw, 1rem);
  }
  li {
    margin: clamp(0.25rem, 1vw, 0.5rem) 0;
    padding-left: clamp(0.125rem, 0.5vw, 0.25rem);
    line-height: 1.6;
  }

  a {
    color: #dc1c2e;
    font-weight: 600;
    text-decoration: underline;
  }
  a:hover {
    color: #a30f1f;
  }
  a:focus {
    outline: 2px solid #dc1c2e;
    outline-offset: 2px;
  }
  /* Accordion */
  .accordion {
    list-style: none;
    margin: clamp(0.5rem, 2vw, 0.75rem) 0 0;
    padding: 0;
    display: grid;
    gap: clamp(0.5rem, 1.5vw, 0.75rem);
  }

  .accordion__item {
    border-radius: clamp(10px, 2vw, 14px);
    background: #fdeceb;
    border-left: 4px solid #dc1c2e;
    transition: background .25s ease, box-shadow .25s ease;
  }

  .accordion__item.is-active {
    color: #fff;
    background: linear-gradient(135deg, #dc1c2e 0%, #8a0f1a 100%);
    border-left: 4px solid #f5b6ba;
    box-shadow: 0 clamp(6px, 2vw, 10px) clamp(12px, 4vw, 24px) rgba(220,28,46,0.25);
  }

  .accordion__button {
    width: 100%;
    border: 0;
    background: transparent;
    display: grid;
    grid-template-columns: minmax(120px, 1fr) 1fr auto;
    gap: clamp(0.75rem, 2vw, 1rem);
    align-items: center;
    padding: clamp(0.75rem, 2vw, 1rem) clamp(0.75rem, 2vw, 1rem) clamp(0.75rem, 2vw, 1rem) clamp(1rem, 2.5vw, 1.25rem);
    cursor: pointer;
    text-align: left;
    border-radius: clamp(10px, 2vw, 14px);
    min-height: 60px;
    overflow: hidden;
  }

  .accordion__title {
    font-weight: 700;
    text-transform: uppercase;
    color: #1d1d1f;
    font-size: clamp(0.85rem, 2.3vw, 0.95rem);
    line-height: 1.4;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .accordion__summary {
    color: #4b5563;
    font-size: clamp(0.85rem, 2vw, 0.95rem);
    line-height: 1.4;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .accordion__cta {
    width: clamp(32px, 8vw, 40px);
    height: clamp(32px, 8vw, 40px);
    border-radius: 999px;
    background: #ffffff;
    position: relative;
    flex-shrink: 0;
  }
  .accordion__cta::after {
    content: '';
    position: absolute;
    inset: 0;
    margin: auto;
    width: clamp(8px, 2vw, 10px);
    height: clamp(8px, 2vw, 10px);
    border-right: clamp(1.5px, 0.4vw, 2px) solid #f2a900;
    border-bottom: clamp(1.5px, 0.4vw, 2px) solid #f2a900;
    transform: rotate(45deg); /* down */
    transition: transform .2s ease;
  }

  .accordion__item.is-active .accordion__title,
  .accordion__item.is-active .accordion__summary {
    color: #ffffff;
  }
  .accordion__item.is-active .accordion__cta::after {
    border-color: #f2a900;
    transform: rotate(-135deg); /* up */
  }

  .accordion__panel {
    padding: 0 clamp(1rem, 2.5vw, 1.25rem) clamp(0.75rem, 2vw, 1rem) clamp(1rem, 2.5vw, 1.25rem);
  }
  .accordion__content p,
  .accordion__content li {
    color: #1e293b;
    font-size: clamp(0.9rem, 2.5vw, 1rem);
    line-height: 1.6;
  }
  .accordion__item.is-active .accordion__content p,
  .accordion__item.is-active .accordion__content li {
    color: #ffd9db;
  }
}

/* Tablet portrait */
@media (min-width: 481px) and (max-width: 767px) {
  .policy {
    padding: clamp(2.5rem, 5vw, 3.5rem) clamp(1.25rem, 3vw, 1.5rem) clamp(4.5rem, 7vw, 6rem);
  }
  .accordion__button {
    grid-template-columns: minmax(120px, 1fr) 1fr auto;
    min-height: 55px;
    overflow: hidden;
  }
}

/* Tablet landscape and small desktop */
@media (min-width: 768px) {
  .policy {
    padding: clamp(3rem, 6vw, 4rem) clamp(1.5rem, 4vw, 2rem) clamp(5rem, 8vw, 7rem);
  }
  .policy .intro {
    grid-template-columns: 1.1fr 1fr;
    align-items: center;
  }
  .accordion__button {
    grid-template-columns: minmax(200px, 1fr) 1fr auto;
    overflow: hidden;
  }
}

/* Large desktop */
@media (min-width: 1200px) {
  .policy {
    padding: 6rem 2rem 8rem;
  }
  .accordion__button {
    grid-template-columns: minmax(250px, 1fr) 1fr auto;
    overflow: hidden;
  }
}

/* Small mobile devices */
@media (max-width: 480px) {
  .policy {
    padding: clamp(2rem, 5vw, 3.25rem) clamp(0.75rem, 2vw, 1rem) clamp(4rem, 8vw, 6.5rem);
  }
  .policy .corner-accent {
    width: 90px;
    height: 90px;
  }
  .accordion__button {
    grid-template-columns: 1fr auto;
    gap: clamp(0.5rem, 1.5vw, 0.75rem);
    min-height: 50px;
    overflow: hidden;
  }
  .accordion__title {
    font-size: clamp(0.85rem, 2.2vw, 0.95rem);
  }
  .accordion__summary {
    display: none; /* Hide summary on very small screens to save space */
  }
}

/* Extra small devices */
@media (max-width: 320px) {
  .accordion__button {
    padding: 0.5rem 0.5rem 0.5rem 0.75rem;
    min-height: 45px;
  }
  .accordion__cta {
    width: 28px;
    height: 28px;
  }
}

/* Touch devices improvements */
@media (hover: none) and (pointer: coarse) {
  .accordion__button {
    min-height: 60px;
    padding: 1rem;
  }
  .accordion__cta {
    width: 44px;
    height: 44px;
  }
}

/* Landscape orientation on mobile */
@media (max-height: 500px) and (orientation: landscape) {
  .policy {
    padding: clamp(1.5rem, 3vw, 2rem) clamp(1rem, 2vw, 1.5rem) clamp(2rem, 4vw, 3rem);
  }
  .accordion__button {
    min-height: 50px;
    padding: 0.75rem;
  }
}
</style>


